<template>
<div class="body">
  <div class="pdf-preview-loader">
    <BaseLoader />
  </div>
  <div class="pdf-wrapper" ref="reportDetails">
    <div class="container">
      <header style="margin-bottom: 40px">
        <div>
          <img src="../img/Logos_TXT.svg" alt="" class="logo">
          <div class="logo-text">
            App for collecting and analysing sport videos using Machine Learning algorithm.
          </div>
        </div>
        <h1 style="max-width: 100%;word-break: break-all">{{video.display_name}}</h1>
      </header>
      <div class="date">REPORT DATE: {{formatEventDate(video.updated_at)|| '&#8212;'}}</div>
      <section>
        <div class="side-content">
          <div class="content-heading">VIDEO</div>
          <img :src="thumbnail" alt="" class="thumbnail">
          <div class="field">
            <h3>TOTAL DURATION, s:</h3>
            <div style="margin-top: -2px">{{video.video_duration_sec || '&#8212;'}}</div>
          </div>
          <div class="field">
            <h3>PLACE:</h3>
            <div style="margin-top: -2px">{{video.event_place || '&#8212;'}}</div>
          </div>
          <div class="field">
            <h3>TYPE:</h3>
            <div style="margin-top: -2px">{{video.event_name || '&#8212;'}}</div>
          </div>
          <div class="field">
            <h3>DATE:</h3>
            <div style="margin-top: -2px">{{formatEventDate(video.event_date) || '&#8212;'}}</div>
          </div>
          <div class="field">
            <h3>DURATION:</h3>
            <div style="margin-top: -2px">{{formatSeconds(video.video_duration_sec) || '&#8212;'}}</div>
          </div>
          <div class="field">
            <h3>RESOLUTION:</h3>
            <div style="margin-top: -2px">{{video.video_width}}x{{video.video_height}}</div>
          </div>
          <div class="field">
            <h3>FPS:</h3>
            <div style="margin-top: -2px">{{video.video_fps.toFixed(2) || '&#8212;'}}</div>
          </div>
          <!--<div class="field">-->
            <!--<h3>DESCRIPTION:</h3>-->
            <!--<div style="margin-top: -2px">-->
              <!--Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>-->
          <!--</div>-->
        </div>
        <div class="main-content">
          <div class="content-heading">BRAND ANALYSIS</div>
          <div class="table">
            <div class="table-row">
              <div class="table-cell" style="width: 13px">NO.</div>
              <div class="table-cell" style="width: 78px;text-align: left">Brand</div>
              <div class="table-cell" style="width: 63px;">Exposure, s</div>
              <div class="table-cell" style="width: 63px;">Exposure, %</div>
              <div class="table-cell" style="width: 49px">Area, %</div>
              <div class="table-cell" style="width: 12px">BIS</div>
            </div>
            <div class="table-row" v-for="(item,index) in video.report" :key="item + index">
              <div class="table-cell"  style="width: 13px">{{index + 1}}</div>
              <div class="table-cell"  style="width: 78px;text-align: left">{{item.brand}}</div>
              <div class="table-cell"  style="width: 63px">{{item.exposure_time_sec.toFixed(1)}}</div>
              <div class="table-cell"  style="width: 63px">{{item.exposure_time_pct.toFixed(1)}}</div>
              <div class="table-cell"  style="width: 49px">{{item.mean_area_pct.toFixed(1)}}</div>
              <div class="table-cell"  style="width: 12px">{{item.bis.toFixed(1)}}</div>
            </div>
          </div>
        </div>
      </section>
      <div class="pdf-footer">
        <span style="max-width: 400px">{{video.display_name}}</span>
        <span>Page 1 / 1</span>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import html2canvas from "html2canvas"
import jsPDF from "jspdf";
import BaseLoader from '../../../components/BaseLoader';
import {formatSeconds} from "../../../utils/utils";
import moment from 'moment'

export default {
  name: "index",
  props: ['name', 'video'],
  components: {BaseLoader},
  data() {
    return {
      doc: null,
      thumbnail: null,
    }
  },
  mounted() {
    this.doc = new jsPDF();
    this.getBase64FromUrl(this.video.thumbnail_url).then((src) => {
      this.thumbnail = src;
      this.printReport();
    })
  },
  methods: {
    formatEventDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    formatSeconds(sec) {
      return formatSeconds(sec);
    },
    async getBase64FromUrl(url){
      const data = await fetch(url);
      const blob = await data.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        }
      });
    },
    printReport() {
      setTimeout(() => {
        html2canvas(this.$refs.reportDetails).then((canvas) => {
          const img = canvas.toDataURL("image/png");

          this.doc.addImage(img, 'PNG', 5, 2, 205, 295, '1', 'NONE');
          this.doc.save(this.video.display_name + '.pdf');

          this.$emit('generated');

        });
      }, 1000)

    },
  }
}
</script>

<style scoped>
  /* --------------------------------------------------------------

   typography.css
   * Sets up some sensible default typography.
   http://www.blueprintcss.org/blueprint/src/typography.css
-------------------------------------------------------------- */

  /* Default font persons.
     The font-size percentage is of 16px. (0.75 * 16px = 12px) */

  html { font-size:100.01%; }
  body, .body {
    font-size: 75%;
    color: #222;
    background: #fff;
    font-family: "AcronisCyber", "Helvetica Neue", Arial, Helvetica, sans-serif;
    box-sizing: unset;
  }


  /* Headings
  -------------------------------------------------------------- */

  h1,h2,h3,h4,h5,h6 { font-weight: bold; font-family: "AcronisCyberBold", sans-serif}

  h1 { font-size: 3em; line-height: 1; margin-bottom: 0.5em; }
  h2 { font-size: 2em; margin-bottom: 0.75em; }
  h3 { font-size: 1.5em; line-height: 1; margin-bottom: 1em; }
  h4 { font-size: 1.2em; line-height: 1.25; margin-bottom: 1.25em; }
  h5 { font-size: 1em; font-weight: bold; margin-bottom: 1.5em; }
  h6 { font-size: 1em; font-weight: bold; }

  h1 img, h2 img, h3 img,
  h4 img, h5 img, h6 img {
    margin: 0;
  }


  /* Text elements
  -------------------------------------------------------------- */

  p           { margin: 0 0 1.5em; }
  /*
      These can be used to pull an image at the start of a paragraph, so
      that the text flows around it (usage: <p><img class="left">Text</p>)
   */
  .left  			{ float: left !important; }
  p .left			{ margin: 1.5em 1.5em 1.5em 0; padding: 0; }
  .right 			{ float: right !important; }
  p .right 		{ margin: 1.5em 0 1.5em 1.5em; padding: 0; }

  a:focus,
  a:hover     { color: #09f; }
  a           { color: #06c; text-decoration: underline; }

  blockquote  { margin: 1.5em; color: #666; font-style: italic; }
  strong,dfn	{ font-weight: bold; }
  em,dfn      { font-style: italic; }
  sup, sub    { line-height: 0; }

  abbr,
  acronym     { border-bottom: 1px dotted #666; }
  address     { margin: 0 0 1.5em; font-style: italic; }
  del         { color:#666; }

  pre         { margin: 1.5em 0; white-space: pre; }
  pre,code,tt { font: 1em 'andale mono', 'lucida console', monospace; line-height: 1.5; }


  /* Lists
  -------------------------------------------------------------- */

  li ul,
  li ol       { margin: 0; }
  ul, ol      { margin: 0 1.5em 1.5em 0; padding-left: 1.5em; }

  ul          { list-style-type: disc; }
  ol          { list-style-type: decimal; }

  dl          { margin: 0 0 1.5em 0; }
  dl dt       { font-weight: bold; }
  dd          { margin-left: 1.5em;}


  /* Tables
  -------------------------------------------------------------- */

  /*
      Because of the need for padding on TH and TD, the vertical rhythm
      on table cells has to be 27px, instead of the standard 18px or 36px
      of other elements.
   */
  /*table       { margin-bottom: 1.4em; width:100%; }*/
  /*th          { font-weight: bold; text-align: center }*/
  /*thead th    { background: #c3d9ff; }*/
  /*th,td,caption { padding: 4px 10px 4px 5px; }*/
  /*
      You can zebra-stripe your tables in outdated browsers by adding
      the class "even" to every other table row.
   */
  /*tbody tr:nth-child(even) td,*/
  /*tbody tr.even td  {*/
  /*background: #e5ecf9;*/
  /*}*/
  /*tfoot       { font-style: italic; }*/
  /*caption     { background: #eee; }*/

  /* Misc classes
  -------------------------------------------------------------- */

  .small      { font-size: .8em; margin-bottom: 1.875em; line-height: 1.875em; }
  .large      { font-size: 1.2em; line-height: 2.5em; margin-bottom: 1.25em; }
  .hide       { display: none; }

  .quiet      { color: #666; }
  .loud       { color: #000; }
  .highlight  { background:#ff0; }
  .added      { background:#060; color: #fff; }
  .removed    { background:#900; color: #fff; }

  .first      { margin-left:0; padding-left:0; }
  .last       { margin-right:0; padding-right:0; }
  .top        { margin-top:0; padding-top:0; }
  .bottom     { margin-bottom:0; padding-bottom:0; }

  body, html, .body {
    box-sizing: unset;
    padding: 0;
    height: 860px;
    /*transform: scale(1.15);*/
  }

  .body {
    /*margin: 0 auto;*/
    /*margin-top: 10%;*/
  }

  .math {
    margin-top: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px !important;
    line-height: 15px;
    color: #00204D;
  }

  svg {
    transform: translateX(-3.4%) scale(1.11);
  }

  header {
    border-top: 0.5px solid #00204D;
    padding-top: 10px;
    display: flex;
    margin-bottom: 120px;
  }

  .pdf-footer {
    position: absolute;
    bottom: 0;
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px solid #00204D;
  }

  section {
    display: flex;
  }

  span, h3, th, td, div {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #00204D;
    text-align: left;
  }

  th {
    margin-right: 10px;
  }

  .table-cell {
    text-align: center;
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #00204D;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin-right: 10px;
  }

  h3 {
    font-weight: bold;
    margin: 0;
  }

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: #00204D;
    margin: 0;
    width: 340px;
    word-break: break-word;
  }

  .table-row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-bottom: 18px;

    position: static;
    width: 340px;
    height: 11px;
    left: 0px;
    top: 0px;

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 9px 0px;

    border-bottom: 0.5px solid #00204D;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .no-border {
    border: none;
    height: 11px;
  }

  .no-padding {
    padding: 0;
  }

  .pt-20 {
    padding-top: 20px;
  }

  .mt-45 {
    margin-top: 45px;
  }

  .mt-30 {
    margin-top: 30px;
  }

  .mt-25 {
    margin-top: 25px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .no-margin {
    margin: 0;
  }

  .container {
    position: relative;
    width: 510px;
    height: 780px;
    background: #FFFFFF;
    margin: 0 auto;
  }

  .pdf-wrapper {
    position: relative;
    width: 593px;
    background: #FFFFFF;
    margin: 0 auto;
    padding: 30px 0;
  }

  .date {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #00204D;
    margin: 0;
    margin-bottom: 10px;
  }

  .side-content {
    width: 150px;
    margin-right: 20px;
  }

  .side-content-2 {
    width: 320px;
    margin-right: 20px;
  }

  .main-content-2 {
    width: 170px;
    box-sizing: unset;
  }

  .main-content {
    width: 340px;
  }

  .content-heading {
    padding-bottom: 10px;
    border-bottom: 2px solid #00204D;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #00204D;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-heading > span {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    text-align: right;
    color: #00204D;
  }

  .content-heading--sec {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 10px;
    display: flex;
    align-items: flex-end;
    color: #727984;
    padding-bottom: 10px;
    border-bottom: 2px solid #00204D;
    max-height: 20px;
    box-sizing: unset;
  }

  .logo {
    margin-right: 20px;
    width: 150px;
    height: 20px;
  }

  .logo-text {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 10px;
    color: #727984;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 10px 0px;
    width: 150px;
  }

  .thumbnail {
    width: 150px;
    height: 84px;
    background: rgba(36, 49, 67, 0.1);
    margin: 20px 0;
    object-fit: cover;
  }

  .field {
    margin-bottom: 10px;
    word-break: break-word;
  }

  .page-row {
    display: flex;
  }

  .apexcharts-zoom-icon, .apexcharts-reset-icon, .apexcharts-menu-icon {
    display: none;
  }

  .apexcharts-yaxis-label {
    margin-bottom: 9px;
  }

  .heatmap-story {
    display: block;
    margin-top: 40px;
    width: 320px;
  }

  .heatmap-story-row {
    display: flex;
    align-items: center;
  }

  .heatmap-gradient {
    height: 84px;
    margin-top: 10px;
    margin-left: 20px;
  }

  .arrows {
    height: 82px;
    border-top: 1px solid;
    border-bottom: 1px solid;
    width: 20px;
    margin-top: 10px;
  }

  .more, .less {
    margin-left: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 11px;
    display: flex;
    align-items: flex-end;
    color: #00204D;
  }

  .more {
    margin-bottom: 60px;
  }

  .less {
    margin-bottom: -5px;
  }

  .heatmap-img {
    margin-top: 10px;
    height: 84px;
    width: 150px;
  }

  .heatmap-container {
    display: grid;
    grid-template-columns: 150px 150px 150px;
    grid-gap: 20px;
    grid-row-gap: 40px;
    flex-wrap: wrap;
  }

  .heatmap {
    flex: 1;
  }

  .no-margin-x {
    margin-left: 0;
    margin-right: 0;
  }

  .para2 {
    max-width: 170px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .para {
    max-width: 150px;
    margin-top: 10px;
    word-break: break-word;
  }

  .formula-row {
    display: flex;
    align-items: flex-start;
    max-width: 150px;
  }

  .formula-row > span {
    max-width: 120px;
  }

  .formula-char {
    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 11px;
    display: flex;
    align-items: flex-end;
    color: #00204D;
    width: 20px;
  }

</style>

